import { create } from "zustand";
import { ROUTES } from "@/shared";

interface NavigationStore {
  targetRoute: ROUTES | null;
  pendingRoute: string | null;
  redirectRoute: string | null;
  setPendingRoute: (route: string | null) => void;
  setTargetRoute: (route: ROUTES | null) => void;
  setRedirectRoute: (route: string | null) => void;
}

export const useNavigationStore = create<NavigationStore>(set => ({
  targetRoute: null,
  pendingRoute: null,
  redirectRoute: null,

  setPendingRoute: route => set({ pendingRoute: route }),
  setTargetRoute: route => set({ targetRoute: route }),
  setRedirectRoute: route => set({ redirectRoute: route })
}));
